import Vue from 'vue'

const NewMaterialBoxInstance = Vue.extend(require('./newMaterialBox.vue').default);
let instance = null
let confirmPromise = null
let confirmResolve = null

let getInstance = () => {
  return new NewMaterialBoxInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (confirmResolve) {
    confirmResolve(false)
    confirmResolve = null
  }
  confirmPromise = null
}

let NewMaterialBox = (config, call,i) => {
  if (instance) {
    close()
  }

  if(!config && !i){
    return confirmPromise
  }

  instance = getInstance()

  document.body.appendChild(instance.$el);
  confirmPromise = new Promise((resolve) => {
    confirmResolve = resolve
  })

  instance.open(config, confirmResolve, call,i)

  return confirmPromise
}

export default NewMaterialBox
